import React from 'react';
import { YMaps, Map, Placemark } from '@pbe/react-yandex-maps';

const WeddingMap = () => {
    const mapState = {
        center: [55.56108, 37.639797], // Координаты клуба "ЗаВидное"
        zoom: 14, // Уровень зума для лучшей видимости
    };

    const weddingLocation = [55.56108, 37.639797]; // Точное место проведения

    return (
        <div className="map-section">
            <YMaps>
                <Map defaultState={mapState} className="ant-map">
                    <Placemark
                        geometry={weddingLocation}
                        options={{
                            preset: 'islands#icon',
                            iconColor: '#ff6f61' // Цвет маркера
                        }}
                        properties={{
                            hintContent: 'Загородный клуб "ЗаВидное"',
                            balloonContent: 'Симферопольское шоссе, Ленинский район'
                        }}
                    />
                </Map>
            </YMaps>
        </div>
    );
};

export default WeddingMap;